






import { Component, Vue, Prop } from 'vue-property-decorator';
import { SlideService } from '../../../services/modules/slide';
import { EventBus } from '../../../event-bus';

@Component({
  components: {}
})
export default class AssetFromArchiveComponent extends Vue {
  @Prop({ type: String }) id: string | undefined;
  private isLoading: boolean = false;
  async reactivate() {
    if (this.id) {
      this.isLoading = true;
      try {
        await this.$store.dispatch('slides/unarchiveActiveSlide', this.id);
        this.$emit('update');
        EventBus.$emit('update-header', true);
      } catch (error) {
        this.$store.dispatch('alerts/warning', 'Not able to update slide.');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
